import React from 'react';
import Checkbox from './Checkbox';
import CheckboxItem from '@/types/checkbox-item';

interface Props {
  items: CheckboxItem[];
  onChange: (selected: CheckboxItem[]) => void;
  disabled: boolean;
}

interface State {
  selected: CheckboxItem[];
}

class CheckboxGroup extends React.Component<Props, State> {
  readonly state: State = {
    selected: [],
  };

  static defaultProps = {
    items: [],
    onChange: () => {},
    disabled: false,
  };

  onCheckboxChange = (item: CheckboxItem, toggled: boolean) => {
    const selected = this.state.selected.slice();
    if (toggled) {
      selected.push(item);
    } else {
      selected.splice(
        selected.findIndex(s => s === item),
        1,
      );
    }

    this.setState({ selected });
    this.props.onChange(selected);
  };

  render() {
    return (
      <div className="checkbox-group">
        {this.props.items.map((item, i) => (
          <Checkbox
            key={i}
            disabled={this.props.disabled}
            onChange={(toggled: boolean) => this.onCheckboxChange(item, toggled)}
            selected={this.state.selected.some(s => s === item)}
            {...item}
          />
        ))}
      </div>
    );
  }
}

export default CheckboxGroup;
